/* eslint-disable react-hooks/exhaustive-deps */
import { ChangeEvent, FC, useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import { FaFilter, FaSearch, FaSortDown, FaSortUp } from "react-icons/fa";
import { FaSort } from "react-icons/fa6";
import { PulseLoader } from "react-spinners";
import Fastbackwordpage from "../../icons/Vector.svg?react";
import Fastforwordpage from "../../icons/f1page.svg?react";
import Forwordpage from "../../icons/fpage.svg?react";
import Backwordpage from "../../icons/rpage.svg?react";
import SubmitButton from "../Button";
import CustomSelect from "../Dropdown";
import styles from "./style.module.scss";
interface ColumnData {
  key: string | number;
  label: string;
  alignText?: string;
  tdClassname?: string;
  disableSortBy?: boolean;
  isMoreField?: boolean;
}
interface StateProps {
  columnData: ColumnData[];
  rowData: any;
  title: string;
  totalResult?: number;
  enableFilter?: boolean;
  enableActionButton?: boolean;
  enableMoreFeilds?: boolean;
  enableFilterButton?: boolean;
  enableCheckbox?: boolean;
  buttonValue?: string;
  FilterValue?: any;
  CheckboxText?: string;
  MoreFeildsValue?: any;
  isCheckboxChecked?: boolean;
  onCheckboxToggle?: (checked: boolean) => void;
  buttonOnClick?: (data: any) => void;
  onPageLimitChange: (newLimit: number) => void;
  onPageNoChange: (page: number) => void;
  tableBottomButton?: boolean;
  checkBox?: boolean;
  handleCheckboxChange?: (
    e: React.ChangeEvent<HTMLInputElement>,
    row: any
  ) => void;
  handleSelectAllCheckbox?: (
    e: React.ChangeEvent<HTMLInputElement>,
    row: any
  ) => void;
  isRowChecked?: (row: any) => boolean;
  isSelectAllChecked?: () => boolean;
  disableCheckBoxField?: string;
  currentPage?: number;
  setCurrentPage?: (data: any) => void;
  showLoading?: boolean;
  noRecordMessage?: string;
  showHeader?: boolean;
  onClickBack?: (data: any) => void;
  itemsPerPage: number;
  customSearchContainerClass?: string;
  maxTableHeight?: string;
}

const TableContainer: FC<StateProps> = ({
  columnData = [],
  rowData,
  title,
  CheckboxText = "",
  enableFilter = false,
  enableActionButton = false,
  enableMoreFeilds = false,
  enableFilterButton = false,
  enableCheckbox = false,
  buttonValue = "",
  FilterValue,
  MoreFeildsValue,
  isCheckboxChecked = false,
  onCheckboxToggle = () => { /* noop */  },
  itemsPerPage,
  buttonOnClick,
  tableBottomButton = false,
  checkBox = false,
  handleCheckboxChange,
  handleSelectAllCheckbox,
  isSelectAllChecked,
  isRowChecked,
  disableCheckBoxField,
  currentPage = 1,
  totalResult = 100,
  setCurrentPage,
  onPageLimitChange,
  onPageNoChange,
  showLoading = false,
  noRecordMessage = "No records",
  showHeader = true,
  customSearchContainerClass,
  onClickBack = () => {},
  maxTableHeight = "60vh",
}) => {
  const [columns, setColumns] = useState(columnData);
  const [searchTerm, setSearchTerm] = useState("");
  const [pageInput, setPageInput] = useState(currentPage);
  const sizeOfPage = itemsPerPage !== undefined ? itemsPerPage : 10;
  const [pageSizeInput, setPageSizeInput] = useState(sizeOfPage);
  const totalPageCount = totalResult
    ? Math.ceil(totalResult / itemsPerPage)
    : 0;
  const isLastPage = currentPage === totalPageCount;
  const [tableRows, setTableRows] = useState(rowData);
  const [selectedFilters, setSelectedFilters] = useState<any[]>([]);
  const [sortColumn, setSortColumn] = useState<string | null>(null);
  const [sortDirection, setSortDirection] = useState<"asc" | "desc" | "">("");
  const startIndex = currentPage * sizeOfPage + 1 - itemsPerPage;
  const endIndex = Math.min(currentPage * sizeOfPage, totalResult);
  const handleSearch = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value.toLowerCase();
    setSearchTerm(value);

    const filteredData = rowData.filter((item: any) => {
      return Object.values(item).some((val: any) => {
        if (val) {
          return val.toString().toLowerCase().includes(value);
        } else {
          return null;
        }
      });
    });

    setTableRows(filteredData);
    if (setCurrentPage) setCurrentPage(1); // Reset to first page on search
  };
  //to rerender component whenever data updates
  useEffect(() => {
    setTableRows(rowData);
  }, [rowData]);

  const handleSort = (columnKey: string) => {
    let direction: "asc" | "desc" | "" = "asc";

    if (sortColumn === columnKey && sortDirection === "asc") {
      direction = "desc";
    } else if (sortColumn === columnKey && sortDirection === "desc") {
      direction = "";
    }

    setSortColumn(columnKey);
    setSortDirection(direction);

    const sorted = [...tableRows].sort((a, b) => {
      const valA = a[columnKey];
      const valB = b[columnKey];

      if (valA === null || valA === undefined) return 1;
      if (valB === null || valB === undefined) return -1;

      if (typeof valA === "string" && typeof valB === "string") {
        return direction === "asc"
          ? valA.localeCompare(valB)
          : valB.localeCompare(valA);
      }

      return direction === "asc"
        ? valA > valB
          ? 1
          : -1
        : valA < valB
          ? 1
          : -1;
    });

    setTableRows(sorted);
  };

  const handlePreviousClick = () => {
    if (currentPage > 0) {
      const newPageNumber = currentPage - 1;
      onPageNoChange(newPageNumber);
      setPageInput(newPageNumber);
    }
  };

  const handleNextClick = () => {
    const newPageNumber = currentPage + 1;
    onPageNoChange(newPageNumber);
    setPageInput(newPageNumber);
  };
  const handlePageSizeChange = (newPageSize: number) => {
    if (!isNaN(newPageSize)) {
      onPageLimitChange(newPageSize);
    }
  };

  const handleInputChangePage = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(e.target.value, 10);
    if (!isNaN(value) && value <= totalPageCount) {
      setPageInput(value);
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      const newPage = parseInt((e.target as HTMLInputElement).value, 10);
      if (!isNaN(newPage) && newPage > 0 && newPage <= totalPageCount) {
        onPageNoChange(newPage - 1);
      } else {
        setPageInput(currentPage + 1);
      }
    }
  };

  const handleBlurPageInput = () => {
    if (pageInput < currentPage + 1) {
      setPageInput(currentPage + 1);
    }
  };

  useEffect(() => {
    setPageInput(currentPage);
  }, [currentPage]);

  const handleInputChangePageSize = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = e.target.value;
    if (/^\d*$/.test(value) && Number(value) <= 100) {
      setPageSizeInput(Number(value)); // ✅ OK since it's string
    }
  };

  const handleKeyPressPagesize = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      const newSize = Number(pageSizeInput);
      if (newSize >= 1 && newSize <= 100) {
        handlePageSizeChange(newSize);
      }
    }
  };

  useEffect(() => {
    setPageSizeInput(sizeOfPage);
  }, []);

  const handleBlurPageSize = () => {
    const newSize = Number(pageSizeInput);
    if (!newSize || newSize < 1 || newSize > 100) {
      setPageSizeInput(sizeOfPage);
    } else {
      handlePageSizeChange(newSize);
    }
  };

  const handleFirstPageClick = () => {
    setPageInput(1);
    onPageNoChange(1);
  };

  const handleLastPageClick = () => {
    setPageInput(totalPageCount);
    onPageNoChange(totalPageCount);
  };

  const handleAllChecked = (e: ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked;
    const updatedData = tableRows.map((element: any) => {
      const isDisabled = element[disableCheckBoxField as any];
      return {
        ...element,
        checked: isDisabled ? false : isChecked,
      };
    });
    setTableRows(updatedData);
  };

  const allChecked =
    tableRows.length > 0 &&
    tableRows.every(
      (item: any) => item.checked || item[disableCheckBoxField as any]
    );

  const someChecked = tableRows.some((item: any) => item.checked);

  const handleButtonOnClick = () => {
    buttonOnClick?.(tableRows);
  };

  const handleMoreFieldsButtonClick = (selectedValues: any[]) => {
    setSelectedFilters(selectedValues);

    const updatedColumns = columns.map((col) => {
      if (col.isMoreField !== undefined && col.isMoreField !== null) {
        const isSelected = selectedValues.some((f) => f.value === col.key);
        return { ...col, isMoreField: !isSelected }; // selected → visible (false), unselected → hidden (true)
      }
      return col;
    });

    setColumns(updatedColumns);
  };

  const visibleColumns = columns.filter((col) => !col.isMoreField);
  const tableStyle = showHeader ? styles.tableContainer : "";
  return (
    <>
      <div className={tableStyle}>
        {showHeader && (
          <div className={styles.searchHeader}>
            <div className={styles.title}>{title} </div>
            {enableCheckbox && (
              <div className="d-flex form-check form-switch">
                <label className={styles.toggleControl}>
                  <input
                    type="checkbox"
                    checked={allChecked}
                    onChange={handleAllChecked}
                    ref={(el) => {
                      if (el) el.indeterminate = !allChecked && someChecked;
                    }}
                  />
                  <span className={styles.control}></span>
                </label>

                <label
                  className={styles.checkboxheader}
                  htmlFor="flexSwitchCheckChecked"
                >
                  {CheckboxText}
                </label>
              </div>
            )}
            {enableFilterButton && (
              <CustomSelect
                iconBeforePlaceholder={
                  <FaFilter className={styles.filterIcon} />
                }
                options={FilterValue}
                placeholder="Filters"
                inputContainerClassName={styles.filterinput}
                arrowClassName={styles.filterarrow}
                multiSelect={true}
                withSelectAll={true}
                onChange={() => {}}
              />
            )}
            {enableMoreFeilds && (
              <CustomSelect
                options={MoreFeildsValue}
                placeholder="More Fields"
                multiSelect={true}
                withSelectAll={true}
                onChange={(val) => handleMoreFieldsButtonClick(val)}
                value={selectedFilters}
              />
            )}
            {enableActionButton && (
              <div className={styles.actionButton}>
                <SubmitButton onClick={handleButtonOnClick}>
                  {buttonValue}
                </SubmitButton>
              </div>
            )}
            {enableFilter && (
              <div
                className={`${styles.searchContainer} ${customSearchContainerClass || ""}`}
              >
                <Form.Control
                  type="text"
                  placeholder="Search"
                  value={searchTerm}
                  onChange={handleSearch}
                  className={styles.searchInput}
                />
                <FaSearch className={styles.searchIcon} />
              </div>
            )}
          </div>
        )}
        <div
          className={`${styles.table_wrapper} custom_scroll`}
          style={{ maxHeight: maxTableHeight }}
        >
          <Table className={`${styles.table} table-bordered`}>
            <thead>
              <tr>
                {checkBox && (
                  <th style={{ width: "10px" }}>
                    &nbsp;
                    <input
                      type="checkbox"
                      onChange={(e) => handleSelectAllCheckbox?.(e, rowData)}
                      checked={isSelectAllChecked?.()}
                    />
                  </th>
                )}
                {visibleColumns.map((column) => (
                  <th
                    key={column.key.toString()}
                    onClick={() =>
                      !column.disableSortBy && handleSort(column.key.toString())
                    }
                    style={{ cursor: "pointer" }}
                  >
                    {column.label}{" "}
                    {!column.disableSortBy && (
                      <span className="sort-icon">
                        {sortColumn === column.key.toString() ? (
                          sortDirection === "asc" ? (
                            <FaSortUp
                              className={styles.sorticon}
                              color="#000000"
                              size={10}
                            />
                          ) : sortDirection === "desc" ? (
                            <FaSortDown
                              className={styles.sorticon}
                              color="#000000"
                              size={10}
                            />
                          ) : (
                            <FaSort
                              className={styles.sorticon}
                              color="#000000"
                              size={10}
                            />
                          )
                        ) : (
                          <FaSort
                            className={styles.sorticon}
                            color="#000000"
                            size={10}
                          />
                        )}
                      </span>
                    )}
                  </th>
                ))}
              </tr>
            </thead>
            {showLoading && (
              <tbody>
                <tr>
                  <td
                    colSpan={visibleColumns.length + 2}
                    style={{
                      height: "50px",
                      textAlign: "center",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",

                        alignItems: "center",
                      }}
                    >
                      <PulseLoader size={10} color="#4a4a4a" />
                    </div>
                  </td>
                </tr>
              </tbody>
            )}
            {!showLoading && (
              <tbody>
                {tableRows && tableRows.length === 0 && (
                  <tr>
                    <td
                      colSpan={visibleColumns.length + 2}
                      style={{ textAlign: "center", color: "#d61919" }}
                    >
                      {noRecordMessage}
                    </td>
                  </tr>
                )}
                {tableRows &&
                  tableRows.map((item: any) => (
                    <tr key={item.id}>
                      {checkBox && (
                        <td style={{ textAlign: "center" }}>
                          &nbsp;
                          <input
                            type="checkbox"
                            onChange={(e) => handleCheckboxChange?.(e, item)}
                            checked={isRowChecked?.(item)}
                          />
                        </td>
                      )}
                      {visibleColumns.map((column) => (
                        <>
                          { }
                          <td
                            className={column.tdClassname}
                            style={{
                              textAlign: column.alignText
                                ? column.alignText
                                : ("" as any),
                            }}
                          >
                            {item[column.key as any]}
                          </td>
                        </>
                      ))}
                    </tr>
                  ))}
              </tbody>
            )}
          </Table>
        </div>
        {totalPageCount > 0 && (
          <div className="d-flex justify-content-between align-items-center mt-3 mb-0">
            <div className="pagination-info d-flex align-items-center">
              <span className={styles.page}>
                Showing <strong>{startIndex}</strong> to{" "}
                <strong>{endIndex}</strong> of <strong>{totalResult}</strong>{" "}
                records
              </span>
            </div>
            <div className="d-flex justify-content-center">
              <div className="d-flex align-items-center">
                <div className="pe-3">
                  <button
                    onClick={handleFirstPageClick}
                    className={styles.paginationicon}
                    disabled={currentPage === 1}
                    data-testid="first-page-btn"
                  >
                    <Fastbackwordpage />
                  </button>
                </div>

                <div className="pe-3">
                  <button
                    className={styles.paginationicon}
                    onClick={handlePreviousClick}
                    disabled={currentPage === 1}
                    data-testid="prev-page-btn"
                  >
                    <Backwordpage />
                  </button>
                </div>

                <div className={styles.page}>Page</div>

                <div className={styles.rectangle}>
                  <input
                    className={styles.rectangle}
                    type="text"
                    inputMode="numeric"
                    value={pageInput}
                    min={1} // Ensure the minimum value is 1
                    max={totalPageCount}
                    disabled={true}
                    onChange={handleInputChangePage}
                    onKeyPress={handleKeyPress}
                    onBlur={handleBlurPageInput}
                  />
                </div>

                <div className={styles.pageresult}>of {totalPageCount}</div>

                <div className="ps-3 pagestyle">
                  <button
                    className={styles.paginationicon}
                    onClick={handleNextClick}
                    disabled={isLastPage}
                    data-testid="next-page-btn"
                  >
                    <Forwordpage />
                  </button>
                </div>

                <div className="ps-3 pagestyle">
                  <button
                    onClick={handleLastPageClick}
                    className={styles.paginationicon}
                    disabled={isLastPage}
                    data-testid="last-page-btn"
                  >
                    <Fastforwordpage />
                  </button>
                </div>
              </div>
            </div>
            <div className="">
              <ul className="checkStyle">
                <li className={styles.rowsPerPage}>
                  <label className={styles.page} htmlFor="page-size-select">
                    Rows per page{" "}
                  </label>

                  <div className="form-group mb-1 inline-page-input">
                    <input
                      className={styles.rectanglerow}
                      type="text"
                      inputMode="numeric"
                      pattern="[0-9]*"
                      value={pageSizeInput}
                      min="1"
                      max="100"
                      onChange={handleInputChangePageSize}
                      onKeyPress={handleKeyPressPagesize}
                      onBlur={handleBlurPageSize}
                    />
                  </div>
                </li>
              </ul>
            </div>
          </div>
        )}
        {tableBottomButton && rowData.length > 0 && (
          <div className={styles.tableBottomButton}>
            <SubmitButton type="secondary" onClick={onClickBack}>
              Back
            </SubmitButton>
            &nbsp;&nbsp;
            <SubmitButton onClick={handleButtonOnClick}>
              {buttonValue}
            </SubmitButton>
          </div>
        )}
      </div>
    </>
  );
};

export default TableContainer;
